import Page from "webPage/Page";
import ReportForm from "../ReportForm";

Page.register('/report-now', () => {
    new ReportForm($(".report-now"));
});
